module.exports = __webpack_public_path__ + "img/agent.956825fa.jpg";